<div class="add-container">
    <h1 class="add-title">Adaugă Zi Liberă</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
      <div class="row">
        <div class="col">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>Nume</mat-label>
            <input type="text" matInput formControlName="off_day_name" />
          </mat-form-field>
          <mat-error *ngIf="!form.controls['off_day_name'].valid && form.controls['off_day_name'].touched">
            Câmp obligatoriu
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col">
            <mat-form-field>
                <input matInput [matDatepicker]="picker" placeholder="Alegeti o data" (dateChange)="onDateChange($event)" formControlName="date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex justify-content-between">
          <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
            {{ helper.dialogConfig.buttonLabels.close }}
          </button>
          <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
            {{ helper.dialogConfig.buttonLabels.save }}
          </button>
        </div>
      </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
      <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
      </div>
    </div>
  </div>
